import { Box, Typography, styled } from '@mui/material';

export const StepGuideContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
  padding: theme.spacing(2),
  display: 'flex ',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const SideBarTitle = styled(Typography)({
  fontSize: 32,
  letterSpacing: 'normal',
  lineHeight: 'normal',
  textAlign: 'center',
});

export const StepsContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'baseline',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StepsItemsContainer = styled(Box)(({ theme }) => ({
  width: '33%',
  minWidth: theme.spacing(20),
  padding: theme.spacing(2),
  [theme.breakpoints.down('desktop')]: {
    minWidth: theme.spacing(17),
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    textAlign: 'center',
  },
}));
